import { type NextBestAction } from '@post-office/confluence-next-best-action';
import { defaultMessageBackend } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

import { CreateWithRovo } from './components/create-with-rovo';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { type MessageTemplateContext } from '../../../index';

export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	onSideNavClick: (nextBestActionType: NextBestAction) => string | void | null;
};

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({
			nextBestActionType,
			handleOnDismissed,
			onSideNavClick,
		}: MessageFrontendProps) => {
			return (
				<CreateWithRovo
					action={nextBestActionType}
					onPrimaryActionClick={onSideNavClick}
					onDismissClick={handleOnDismissed}
				/>
			);
		},
	},
});
